import { ToggleMoreVideos } from './toggle_more_videos';

Alpine.data('toggleMoreVideos', () => new ToggleMoreVideos());
